import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from "./components/utils/scrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import { ConsentProvider } from "./consent/ConsentContext";

// ConsentProvider est à l'intérieur du routeur : le bandeau et le panneau
// renvoient vers les CGU avec un <Link>, qui a besoin du contexte de routage.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <ScrollToTop />
      <ConsentProvider>
        <App />
      </ConsentProvider>
    </BrowserRouter>
  </ErrorBoundary>
);

